import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { getErpJwtToken } from 'app/services/auth/erp-auth-token.util';

/**
 * Ajoute Authorization: Bearer <jwt_erp> sur les appels gateway ERP
 * (users, acces-logiciel-caisse, etc.).
 */
@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = getErpJwtToken();
    const isAcces = request.url.includes('/api/users/acces-logiciel-caisse');

    if (isAcces) {
      console.log('[JwtInterceptor] acces-logiciel-caisse', {
        url: request.url,
        hasJwt: !!token,
        jwtPreview: token ? `${token.slice(0, 12)}...` : null,
      });
    }

    if (!token) {
      return next.handle(request);
    }

    const apiBase = String(environment.apiUrl || '').replace(/\/$/, '');
    const isGatewayUrl = apiBase.length > 0 && request.url.startsWith(apiBase);
    const parametrageUrl = (environment as { parametrage_url?: string }).parametrage_url;
    const paramBase = parametrageUrl ? String(parametrageUrl).replace(/\/$/, '') : '';
    const isParametrageUrl = paramBase.length > 0 && request.url.startsWith(paramBase);

    if (isGatewayUrl || isParametrageUrl) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });
    }

    return next.handle(request);
  }
}
